import angular from 'angular';
import 'angular-sanitize';
import 'ng-mask';
import 'ui-select';

import MainController from '../controllers/MainController';
import EmpreendimentoContactController from '../controllers/EmpreendimentoContactController';
import FormNewsletterController from '../controllers/FormNewsletterController';

const App = angular.module(
  'app.setpar',
  ['ngMask', 'ui.select', 'ngSanitize'],
  [
    '$interpolateProvider',
    ($interpolateProvider) => {
      $interpolateProvider.startSymbol('[[');
      $interpolateProvider.endSymbol(']]');
    },
  ]
);

App.controller('MainController', ['$http', '$scope', MainController])
  .controller('EmpreendimentoContactController', [
    '$http',
    '$timeout',
    EmpreendimentoContactController,
  ])
  .controller('FormNewsletterController', [
    '$http',
    '$timeout',
    FormNewsletterController,
  ]);

export default App;
